import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import VideoBgAdvertising from "../../assets/bgAdvertising.mp4";
import MediaLogo from "../../assets/MEDIA2-cropped.png";
import NavbarV3 from "../../components/Navbar/NavbarV3";
import AdvertisingRequestModal from "../../components/ContactUsButton/AdvertisingRequestModal";
import OutOfHomeFAQ from "../../components/OutOfHomeFAQ/OutOfHomeFAQ";
import OutOfHomeFinalCta from "../../components/OutOfHomeFinalCta/OutOfHomeFinalCta";
import Footer from "../../components/Footer/Footer";
import "../OutOfHome/OutOfHome.css";
import "../OutOfHome/OutOfHomeSections.css";

// Thin, keyword-focused landing pages (product angle, indoor-vs-outdoor
// angle, company-positioning angle) - each reuses the existing FAQ and
// final CTA from /out-of-home, but gets its own short hero/intro instead
// of the full hero/stats/why/process stack. FR-only for now; see
// languageRouting.js once an /en version exists for these.
const SERVICE_SLUGS = {
  affichageNumerique: "affichage-numerique",
  publiciteInterieure: "publicite-interieure",
  compagnieMedia: "compagnie-media",
};

const ServicePage = ({ pageKey }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const slug = SERVICE_SLUGS[pageKey];
  const canonical = `https://www.distributiondrinq.ca/${slug}`;

  return (
    <div className="d-flex flex-column">
      <Helmet>
        <html lang="fr" />
        <title>{t(`seo.services.${pageKey}.title`)}</title>
        <meta name="description" content={t(`seo.services.${pageKey}.description`)} />
        <link rel="canonical" href={canonical} />
      </Helmet>

      <NavbarV3
        logo={MediaLogo}
        logoAlt="DRINQ Média"
        logoHeightTop="105px"
        logoHeightScrolled="72px"
        logoHeightMobile="39px"
      />

      <div
        className="position-relative w-100"
        style={{ maxHeight: "560px", overflow: "hidden" }}
      >
        <video
          src={VideoBgAdvertising}
          autoPlay
          loop
          muted
          playsInline
          className="w-100"
          style={{ objectFit: "cover", height: "560px" }}
        />

        <div
          className="position-absolute top-50 text-white w-100"
          style={{ transform: "translateY(-50%)" }}
        >
          <div className="text-md-start text-center ps-md-5 ps-lg-4 ps-xl-5">
            <h1
              className="fw-bold mb-4 d-none d-xl-block"
              style={{ fontSize: "64px", letterSpacing: "0.01em", lineHeight: 1.1, maxWidth: "760px" }}
            >
              {t(`outOfHomePage.services.${pageKey}.h1`)}
            </h1>
            <h1
              className="fw-bold mb-4 d-block d-xl-none"
              style={{ fontSize: "38px", letterSpacing: "0.01em", lineHeight: 1.1 }}
            >
              {t(`outOfHomePage.services.${pageKey}.h1`)}
            </h1>

            <p
              className="fw-light mb-4"
              style={{ fontSize: "18px", maxWidth: "680px" }}
            >
              {t(`outOfHomePage.services.${pageKey}.intro`)}
            </p>

            <div className="d-flex flex-wrap justify-content-center justify-content-md-start gap-3">
              <Button
                style={{ backgroundColor: "white", borderColor: "white" }}
                onClick={openModal}
                className="button-advertising start-advertising-btn px-2 py-2 px-xl-4 py-xl-3 rounded-4 fw-semibold d-flex align-items-center gap-2"
              >
                <span className="ooh-gradient-text">
                  {t("outOfHomePage.services.cta")}
                </span>
              </Button>
            </div>

            <Link
              to="/out-of-home"
              className="d-inline-block mt-3"
              style={{
                fontSize: "14px",
                color: "rgba(255, 255, 255, 0.75)",
                textDecoration: "underline",
              }}
            >
              {t("outOfHomePage.services.backLink")}
            </Link>
          </div>
        </div>
      </div>

      <div className="oohs-backdrop">
        <OutOfHomeFAQ />
        <OutOfHomeFinalCta openModal={openModal} />
      </div>
      <Footer />

      <AdvertisingRequestModal show={showModal} handleClose={closeModal} />
    </div>
  );
};

export default ServicePage;
